import { Parallax, ParallaxLayer } from "@react-spring/parallax";
import React, { Fragment, useLayoutEffect, useMemo, useState } from "react";

function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function randomTime() {
  return Math.round((Math.random() * (3 - 1 + 1) + 1) * 100) / 100;
}
class CustomImage extends React.Component {
  constructor({ src, style }) {
    super();
    const { width, positionX, poistionY } = style;
    this.src = src;
    this.x = positionX;
    this.y = poistionY;
    this.width = width;
  }
  render() {
    return (
      <img
        width={this.width}
        src={this.src}
        alt={"img"}
        className={"dark-layer2 fadeIn"}
        style={{
          animation: `fadeIn ${randomTime()}s`,
          position: "absolute",
          width: this.width,
          left: this.x + "px",
          top: this.y + "px",
        }}
      />
    );
  }
}

export function BackgroundGalery({ images: imagesArr, height, layer }) {
  const getPositions = (imagesArr, height, layer) => {
    const createdImagesArr = [];
    const expectedImages = imagesArr.length;
    const protection = 300;
    const minWidth = 200 / layer;
    const maxWidth = 350 / layer;
    let image = {};
    let overlapping = false;
    let counter = 0;

    while (createdImagesArr.length < expectedImages && counter < protection) {
      const itemWidth = getRandomInt(minWidth, maxWidth);
      let y;
      y = getRandomInt(15, height / 2);
      if (counter > protection / 2) {
        y = getRandomInt(height / 2, height - (itemWidth + 15));
      }
      image = {
        x: getRandomInt(15, window.innerWidth - (itemWidth + 15)),
        y: y,
        w: itemWidth,
      };
      overlapping = false;

      for (var i = 0; i < createdImagesArr.length; i++) {
        var existing = createdImagesArr[i];
        const distX = image.x - existing.x;
        const distY = image.y - existing.y;
        const distW = image.w * 0.9 + existing.w * 0.9;
        if (Math.abs(distX) < distW && Math.abs(distY) < distW) {
          overlapping = true;
          break;
        }
      }
      if (!overlapping) {
        createdImagesArr.push(image);
      }

      counter++;
    }
    return createdImagesArr;
  };

  const positions = useMemo(
    () => getPositions(imagesArr, height, layer),
    [imagesArr, height, layer]
  );
  let gallery = imagesArr.map((image, i) => {
    if (!positions[i]) {
      return null;
    }
    const { x, y, w } = positions[i];
    return (
      <CustomImage
        src={image}
        key={`${image}${i}${w}`}
        style={{ width: w, positionX: x, poistionY: y }}
      />
    );
  });
  return gallery;
}

const BackgroundImagesRender = ({ images, layer }) => {
  const isStatic = images.length < 6;
  const height1 = isStatic ? window.innerHeight : "1200";
  const position = isStatic ? "fixed" : "absolute";
  let [height, setHeight] = useState();
  useLayoutEffect(() => {
    window.addEventListener("scroll", () => {
      setHeight(window.pageYOffset ? window.pageYOffset : 0);
    });

    return window.removeEventListener("scroll", setHeight());
  }, [setHeight, height]);
  return (
    <Fragment>
      <Parallax pages={5}>
        <ParallaxLayer offset={0} speed={0.5}></ParallaxLayer>
      </Parallax>
      <div
        style={{
          position: position,
          transform: `translate3d(0px, -${isStatic ? 0 : height}px, 0px)`,
          willChange: "transform",
        }}
        className="translateAnim d-flex flex-row flex-wrap w-100 random-gallery-container z-index-10 top-0"
      >
        <BackgroundGalery images={images} layer={layer} height={height1} />
      </div>
    </Fragment>
  );
};

export default BackgroundImagesRender;
